import { render } from "./PrivateChat.vue?vue&type=template&id=76ee598b&scoped=true"
import script from "./PrivateChat.vue?vue&type=script&lang=js"
export * from "./PrivateChat.vue?vue&type=script&lang=js"

import "./PrivateChat.vue?vue&type=style&index=0&id=76ee598b&scoped=true&lang=css"

import exportComponent from "C:\\Source\\vueChatApp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ee598b"]])

export default __exports__